// extracted by mini-css-extract-plugin
export default {"info":"styles_info__XpSKa","icon":"styles_icon__mRz5v"};